import React from "react";
import opticOne from "../../images/brandLogos/opticOne.webp";
import revibe from "../../images/brandLogos/revibe.webp";
import midori from "../../images/brandLogos/midori.webp";
import olyoly from "../../images/brandLogos/olyoly.webp";
import shopkees from "../../images/brandLogos/shopkees.webp";
import sneakerSouq from "../../images/brandLogos/sneakerSouq.webp";
import AlQaedTravelAgency from "../../images/brandLogos/AlQaedTravelAgency.webp";
import ThePetsClub from "../../images/brandLogos/ThePetsClub.webp";
import northWood from "../../images/brandLogos/northWood.webp";
import jokesAside from "../../images/brandLogos/jokesAside.webp";
import afradisia from "../../images/brandLogos/afradisia.webp";
import leatherCrafters from "../../images/brandLogos/leatherCrafters.webp";
import RayhaanPerfumes from "../../images/brandLogos/RayhaanPerfumes.webp";
import Prism from "../../images/brandLogos/Prism.webp";
import ChloeConor from "../../images/brandLogos/ChloeConor.webp";

export default function BrandsWithUs() {
  const brands = [
    {
      title: "Sneaker Souq",
      imageUrl: sneakerSouq,
      containerSize: "w-[98px] h-[40px]",
      websiteUrl: "https://sneakersouqq.ae",
      imageWidth: 400,
      imageHeight: 168,
    },
    {
      title: "Shopkees",
      imageUrl: shopkees,
      containerSize: "w-[124px] h-[30px]",
      websiteUrl: "https://www.shopkees.com",
      imageWidth: 2440,
      imageHeight: 613,
    },
    {
      title: "Optic One",
      imageUrl: opticOne,
      containerSize: "w-[112px] h-[70px]",
      websiteUrl: "https://opticone.ae",
      imageWidth: 420,
      imageHeight: 271,
    },
    {
      title: "AlQaed Travel Agency",
      imageUrl: AlQaedTravelAgency,
      containerSize: "w-[116px] h-[42px]",
      websiteUrl: "https://alqaedtravel.com",
      imageWidth: 1079,
      imageHeight: 393,
    },
    {
      title: "Revibe",
      imageUrl: revibe,
      containerSize: "w-[99px] h-[30px]",
      websiteUrl: "https://revibe.me",
      imageWidth: 440,
      imageHeight: 131,
    },
    {
      title: "Midori",
      imageUrl: midori,
      containerSize: "w-[112px] h-[22px]",
      websiteUrl: "https://midorieyewear.com",
      imageWidth: 500,
      imageHeight: 104,
    },
    {
      title: "The Pets Club",
      imageUrl: ThePetsClub,
      containerSize: "w-[94px] h-[58px]",
      websiteUrl: "https://www.thepetsclub.ae",
      imageWidth: 96,
      imageHeight: 58,
    },
    {
      title: "Oly Oly",
      imageUrl: olyoly,
      containerSize: "w-[101px] h-[30px]",
      websiteUrl: "https://olyoly.com",
      imageWidth: 362,
      imageHeight: 104,
    },
    {
      title: "North Wood",
      imageUrl: northWood,
      containerSize: "w-[150px] h-[40px]",
      websiteUrl: "https://www.northwoodwatch.com",
      imageWidth: 568,
      imageHeight: 149,
    },
    {
      title: "Jokes Aside",
      imageUrl: jokesAside,
      containerSize: "w-[110px] h-[110px]",
      websiteUrl: "https://jokesaside.ae",
      imageWidth: 364,
      imageHeight: 360,
    },
    {
      title: "Afradisia",
      imageUrl: afradisia,
      containerSize: "w-[130px] h-[30px]",
      websiteUrl: "https://afradisia.com",
      imageWidth: 204,
      imageHeight: 46,
    },
    {
      title: "Leather Crafters",
      imageUrl: leatherCrafters,
      containerSize: "w-[100px] h-[80px]",
      websiteUrl: "https://theleathercrafters.com",
      imageWidth: 600,
      imageHeight: 600,
    },
    {
      title: "Rayhaan Perfumes",
      imageUrl: RayhaanPerfumes,
      containerSize: "w-[120px] h-[50px]",
      websiteUrl: "https://rayhaanperfumes.com",
      imageWidth: 4000,
      imageHeight: 2250,
    },
    {
      title: "Prism",
      imageUrl: Prism,
      containerSize: "w-[100px] h-[70px]",
      websiteUrl: "https://www.prism-me.com",
      imageWidth: 826,
      imageHeight: 826,
    },
    {
      title: "Chloe Conor",
      imageUrl: ChloeConor,
      containerSize: "w-[110px] h-[75px]",
      websiteUrl: "https://chloeconor.com",
      imageWidth: 500,
      imageHeight: 500,
    },
  ];

  return (
    <section className="flex flex-row items-center justify-start gap-0 max-w-[100vw]">
      <section className="ticker overflow-hidden flex items-center bg-white grow h-full w-full lg:w-[60%] px-5 sm:px-10 pt-0 pb-16 sm:pt-0 sm:pb-0">
        <div className="ticker__list flex items-center gap-x-10 md:gap-x-16 px-6">
          {brands.map((brand, index) => {
            return (
              <div
                key={index}
                className={`p-2.5 cursor-pointer ${brand.containerSize}`}
                onClick={() => {
                  window.open(brand.websiteUrl, "_blank");
                }}
              >
                <p className="hidden">{brand.title}</p>
                <img
                  src={brand.imageUrl}
                  alt={brand.title}
                  className="object-contain"
                  width={brand.imageWidth}
                  height={brand.imageHeight}
                />
              </div>
            );
          })}
        </div>
        <div className="ticker__list flex items-center gap-x-10 md:gap-x-16 px-6">
          {brands.map((brand, index) => {
            return (
              <div
                key={index}
                className={`p-2.5 cursor-pointer ${brand.containerSize}`}
                onClick={() => {
                  window.open(brand.websiteUrl, "_blank");
                }}
              >
                <img
                  src={brand.imageUrl}
                  alt={brand.title}
                  className="object-contain"
                  width={brand.imageWidth}
                  height={brand.imageHeight}
                />
              </div>
            );
          })}
        </div>
      </section>
    </section>
  );
}
